"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Deposit_1 = require("../Deposit");
var Header_1 = __importDefault(require("./Header"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Withdrawal_1 = require("../Withdrawal");
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var PaymentsWithSwitch = function (_a) {
    var _b, _c;
    var paymentSettings = _a.paymentSettings, isFailed = _a.isFailed, isModal = _a.isModal, onCloseModal = _a.onCloseModal;
    var balanceData = (0, swr_hooks_1.useBalance)().data;
    var paymentType = (0, swr_hooks_1.useSwitchPaymentType)().paymentType;
    var payOutMethods = (0, swr_hooks_1.usePayOutMethods)().data;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    (0, common_hooks_1.useDisablePullToRefresh)();
    (0, common_hooks_1.useFixIosKeyboardScrollBug)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) ? (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.closeButton) },
            react_1.default.createElement(ui_components_1.CloseIcon, { onClickHandler: onCloseModal }))) : null,
        react_1.default.createElement(Header_1.default, { balanceData: balanceData, isFailed: isFailed }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, paymentType === swr_hooks_1.PAYMENT_TYPES.DEPOSIT ? (react_1.default.createElement(Deposit_1.Deposit, { paymentSettings: paymentSettings, isModal: true })) : (react_1.default.createElement(Withdrawal_1.Withdrawal, { methods: ((_c = (_b = payOutMethods === null || payOutMethods === void 0 ? void 0 : payOutMethods.payOut) === null || _b === void 0 ? void 0 : _b.getMethods) === null || _c === void 0 ? void 0 : _c.edges) || [], isModal: isModal })))));
};
exports.default = PaymentsWithSwitch;
